import { render } from "./initiative-dialog.vue?vue&type=template&id=2da5bc26&ts=true"
import script from "./initiative-dialog.vue?vue&type=script&lang=ts"
export * from "./initiative-dialog.vue?vue&type=script&lang=ts"

import "./initiative-dialog.vue?vue&type=style&index=0&id=2da5bc26&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__